"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChargingServicesForBusinesses = function IconChargingServicesForBusinesses(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9 13H5v2h6v27H8.085q1.231 1.087 2.604 2H22V20h-.002l-.002-.136C21.883 16.78 19.358 14 16.36 14A6 6 0 0 0 13 15.305V13h-2V9H7v2h2zm4 5.717V20h7c-.044-2.086-1.759-4-3.57-4.002a3.87 3.87 0 0 0-3.406 2.64zM13 22v20h7V22zm28.096-8.781-1.412-1.417-1.86 1.853-1.083-1.083h-.83l-2.102 2.103a5 5 0 0 0-.425 6.588 4.64 4.64 0 0 0 .61 5.814l4.128 4.14.658-.657-.666.668.114.124a1.91 1.91 0 0 1-.114 2.58 1.91 1.91 0 0 1-2.706.002l-.623.62.622-.62-9.81-9.82-1.415 1.413 9.81 9.82.161.152a3.91 3.91 0 0 0 5.375-.153 3.91 3.91 0 0 0 0-5.532l.01-.01-4.13-4.14-.717.715.716-.716-.142-.154a2.64 2.64 0 0 1-.338-2.924c.74.41 1.568.626 2.417.626a5 5 0 0 0 3.536-1.465l2.517-2.517-1.406-1.406 1.816-1.816-1.414-1.414-1.816 1.816-1.34-1.34zm-.528 6.009-4.242-4.242-1.103 1.103a3 3 0 0 0-.02 4.223l.144.137a3 3 0 0 0 4.119-.117zm-12.02 16.105-3.12-3.12-1.415 1.414 3.12 3.12zM18 29v3h-1v-3zm-2 3v-3h-1v3zm2 3v3h-1v-3zm-2 3v-3h-1v3zM8 22v10H7V22z",
    clipRule: "evenodd"
  })));
};

export { IconChargingServicesForBusinesses, IconChargingServicesForBusinesses as default };
